document.addEventListener('DOMContentLoaded', () => {
  const variantSelects = document.querySelectorAll('[data-variant-select]');

  variantSelects.forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      const priceTarget = document.querySelector('[data-product-price]');
      const option = select.selectedOptions[0];

      if (!form || !option) return;
      form.querySelector('[name="id"]').value = option.value;

      if (priceTarget && option.dataset.price) {
        priceTarget.textContent = option.dataset.price;
      }
    });
  });
});
